var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mt-10", attrs: { id: "map" } }),
    _vm.isIslands
      ? _c(
          "div",
          { staticClass: "col-md-12 col-xs-12 col-sm-12 islands-div" },
          [
            _vm._v(
              " The following countries cannot be displayed: Réunion, Seychelles. "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }